import { useEffect, useState } from "react";
import Layout from "../layout/Layout";
import { getApplications } from "../../api/applications";

import './Applications.css';
import ApplicationCard from "./components/ApplicationCard";

function Applications({ loaded, showContact, setShowContact, showMenu, setShowMenu, currentActive, setCurrentActive }) {
  const [applicationsData, setApplicationsData] = useState([]);

  useEffect(() => {
    getApplications()
      .then((res) => setApplicationsData(res))
      .catch((err) => console.log(err))
  }, []);

  return (
    <Layout loaded={loaded} hideContacts showContact={showContact} setShowContact={setShowContact} showMenu={showMenu} setShowMenu={setShowMenu} currentActive={currentActive} setCurrentActive={setCurrentActive}>
      <div className='applications'>
        <h1 className='title'>Pályázatok</h1>

        {applicationsData.length > 0 && 
          <div className='application-list'>
            {applicationsData.map((applicationData) => <ApplicationCard key={applicationData.id} applicationData={applicationData} />)}
          </div>
        }
      </div>
    </Layout>
  )
}

export default Applications;